import '../styles/Hero.css';

function Hero({bannerKey, text1, text2, image, color}) {
  
  const imageSrc = require(`../assets/img/${image}`);

  return (
    <>
      <div className={`banner-hero banner-hero-${bannerKey} ${color}`}>
        <img src={imageSrc} alt='Abbvie - Après-traitement patient' />
        <div className="banner-hero-content">
          <h1>
            <strong>{text1}</strong> <br/>
            {text2}
          </h1>
        </div>
      </div>
    </> 
  )

}

export default Hero